import React from "react";

class ApMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.props.onUpdate !== undefined) this.props.onUpdate(this.ref);
  }

  render() {
    const { mode } = this.props;

    const classes =
      "ApMarker" +
      (mode === "edit_inside" ? " ApMarkerEditInside" : "") +
      (mode === "edit_outside" ? " ApMarkerEditOutside" : "") +
      (mode === "view_highlighted" ? " ApMarkerHighlighted" : "");

    return (
      <div
        ref={this.ref}
        className={classes}
        style={{
          left: `${this.props.position.x}%`,
          top: `${this.props.position.y}%`
        }}
      >
        <i className="fas fa-map-marker" />
        <div id="Indicator" />
      </div>
    );
  }
}

export default ApMarker;



// WEBPACK FOOTER //
// ./src/components/approval/ApMarker.js